import { type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton'

const SupportPageHeader = ({
  title,
  titlePending,
  description,
  backTo,
  backLabel,
  icon: Icon,
  footer,
  className,
}: {
  title: string
  titlePending?: boolean
  description?: string
  backTo?: string
  backLabel?: string
  icon?: LucideIcon
  footer?: ReactNode
  className?: string
}) => (
  <header className={cn('border-b border-border pb-8 mb-10', className)}>
    {backTo ? (
      <Link
        to={backTo}
        className='mb-5 inline-flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-foreground'
      >
        <ChevronLeft className='h-4 w-4' />
        {backLabel}
      </Link>
    ) : null}

    <div className='flex items-start gap-4'>
      {Icon ? (
        <div className='flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary'>
          <Icon className='h-6 w-6' />
        </div>
      ) : null}
      <div className='min-w-0 flex-1'>
        {titlePending ? (
          <Skeleton className='h-9 w-72 max-w-full border-0 opacity-40' />
        ) : (
          <h1 className='text-3xl font-medium mb-0'>{title}</h1>
        )}
        {description ? (
          <p className='mt-3 max-w-2xl text-lg text-muted-foreground'>
            {description}
          </p>
        ) : null}
        {footer ? <div className='mt-4'>{footer}</div> : null}
      </div>
    </div>
  </header>
)

export default SupportPageHeader
